export default "__VITE_ASSET__0ac26913__"